import {AditivoService} from './../../services/aditivo.service';
import {Aditivo} from './../../model/Aditivo';
import {Component, OnInit} from "@angular/core";
import {ActivatedRoute} from '@angular/router';
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";

@Component({
  selector: 'consulta-aditivo',
  templateUrl: './consulta-aditivo.component.html',
  styleUrls: ['./consulta-aditivo.component.scss'],
  standalone: false
})
export class ConsultaAditivoComponent implements OnInit {

  aditivo: Aditivo;

  constructor(
    private service: AditivoService,
    private alertService: BnAlertsService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(
      m => {
        const id = m.get('id');
        this.atualizaAditivo(id);
      }
    );
  }

  private atualizaAditivo(idAditivo: string): void {
    this.aditivo = null;
// FIXME: Apagar código comentado
//    this.motivoDevolucao = null;
    this.service.obterAditivo(idAditivo).subscribe(
      a => {
        this.aditivo = a;
        // if (a.situacaoId === 3921) { // 3921 - Expedido - Rejeitado
        //   this.obterMotivoDevolucao(idAditivo);
        // }
      },
      error => {
        console.log('Houve erro ao obter o aditivo ' + idAditivo + '. ');
        console.debug(error);
        this.alertService.alertaErro('Erro', 'Houve erro ao obter o aditivo ' + idAditivo + '.');
      }
    );
  }

  // private obterMotivoDevolucao(idAditivo: string): void {
  //   this.service.obterMotivoDevolucao(idAditivo).subscribe(
  //     m => {
  //       this.motivoDevolucao = m.mensagem;
  //     },
  //     error => {
  //       this.motivoDevolucao = null;
  //       console.log('Houve erro ao obter o motivo de devolução do aditivo ' + idAditivo + '. ');
  //       console.debug(error);
  //       this.alertService.alertaErro('Erro', 'Houve erro ao obter o motivo de devolução do aditivo ' + idAditivo + '.');
  //     }
  //   );
  // }
}
